// Provisions Plus — Theme JS

document.addEventListener('DOMContentLoaded', function() {

  /* ============================================================
     DESKTOP MEGA DRAWER (hover two-panel, >768px)
     ============================================================ */
  var toggle   = document.getElementById('mobileToggle');
  var menu     = document.getElementById('mobileMenu');
  var overlay  = document.getElementById('mobileOverlay');
  var closeBtn = document.getElementById('mobileClose');
  var mainBtns = document.querySelectorAll('.mega-drawer-main-btn');
  var panels   = document.querySelectorAll('.mega-drawer-panel');
  var deskContent  = document.getElementById('megaDrawerContent');
  var deskSidebar  = document.querySelector('.mega-drawer-sidebar.desk-only');
  var hoverTimer = null;

  function cancelHover(){ if(hoverTimer){ clearTimeout(hoverTimer); hoverTimer=null; } }
  function scheduleClose(){
    cancelHover();
    hoverTimer = setTimeout(clearPanels, 180);
  }
  function clearPanels(){
    cancelHover();
    if(menu) menu.classList.remove('has-active-panel');
    mainBtns.forEach(function(b){ b.classList.remove('is-active'); });
    panels.forEach(function(p){ p.classList.remove('is-active'); });
    if(deskContent) deskContent.classList.add('is-empty');
  }

  function closeMobileMenu(){
    if(menu)    menu.classList.remove('open');
    if(overlay) overlay.classList.remove('open');
    if(toggle)  toggle.setAttribute('aria-expanded','false');
    clearPanels();
    // Reset mobile nav to L0
    document.querySelectorAll('.mob-panel').forEach(function(p){
      p.classList.remove('mob-panel-active');
    });
    var l0 = document.getElementById('mob-l0');
    if(l0) l0.classList.add('mob-panel-active');
  }

  if(toggle) toggle.addEventListener('click', function(){
    if(window.innerWidth > 768) clearPanels();
    if(menu)    menu.classList.add('open');
    if(overlay) overlay.classList.add('open');
    if(toggle)  toggle.setAttribute('aria-expanded','true');
  });

  if(closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
  if(overlay)  overlay.addEventListener('click', closeMobileMenu);
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape') closeMobileMenu();
  });

  function activatePanel(targetId){
    if(!targetId) return;
    cancelHover();
    if(menu) menu.classList.add('has-active-panel');
    if(deskContent) deskContent.classList.remove('is-empty');
    mainBtns.forEach(function(b){ b.classList.toggle('is-active', b.dataset.menuTarget===targetId); });
    panels.forEach(function(p){ p.classList.toggle('is-active', p.id===targetId); });
  }

  mainBtns.forEach(function(btn){
    btn.addEventListener('mouseenter', function(){ if(window.innerWidth>768) activatePanel(btn.dataset.menuTarget); });
    btn.addEventListener('mouseleave', function(){ if(window.innerWidth>768) scheduleClose(); });
    btn.addEventListener('focus', function(){ activatePanel(btn.dataset.menuTarget); });
    btn.addEventListener('click',  function(){ if(window.innerWidth<=768) activatePanel(btn.dataset.menuTarget); });
  });

  if(deskSidebar){
    deskSidebar.addEventListener('mouseenter', function(){ if(window.innerWidth>768) cancelHover(); });
    deskSidebar.addEventListener('mouseleave', function(){ if(window.innerWidth>768) scheduleClose(); });
  }
  if(deskContent){
    deskContent.addEventListener('mouseenter', function(){ if(window.innerWidth>768) cancelHover(); });
    deskContent.addEventListener('mouseleave', function(){ if(window.innerWidth>768) scheduleClose(); });
  }

  clearPanels();

  /* ============================================================
     MOBILE SINGLE-PANEL LEVEL NAV
     ============================================================ */
  function mobGoTo(panelId){
    document.querySelectorAll('.mob-panel').forEach(function(p){
      p.classList.remove('mob-panel-active');
    });
    var target = document.getElementById(panelId);
    if(target){
      target.classList.add('mob-panel-active');
      target.scrollTop = 0;
    }
  }

  document.querySelectorAll('.mob-expand-btn').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      mobGoTo(this.dataset.go);
    });
  });

  document.querySelectorAll('.mob-back-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      mobGoTo(this.dataset.go);
    });
  });

  document.querySelectorAll('.mob-close-btn').forEach(function(btn){
    btn.addEventListener('click', closeMobileMenu);
  });

  /* ============================================================
     PRODUCT PAGE — THUMBNAIL WHEEL SCROLL
     ============================================================ */
  var ppThumbs   = document.querySelectorAll('.pp-thumb');
  var ppThumbCol = document.querySelector('.pp-thumbs');

  if(ppThumbCol && ppThumbs.length > 1 && window.innerWidth > 768){
    ppThumbCol.addEventListener('wheel', function(e){
      e.preventDefault();
      var active = document.querySelector('.pp-thumb.active');
      var idx = 0;
      ppThumbs.forEach(function(t,i){ if(t===active) idx=i; });
      if(e.deltaY > 0) idx = Math.min(idx+1, ppThumbs.length-1);
      else             idx = Math.max(idx-1, 0);
      ppThumbs[idx].click();
    }, { passive:false });
  }

  /* ============================================================
     QUANTITY SELECTOR
     ============================================================ */
  document.querySelectorAll('.qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var inp = btn.parentElement.querySelector('.qty-input');
      if(!inp) return;
      var v = parseInt(inp.value)||1;
      if(btn.dataset.action==='minus') v = Math.max(1,v-1);
      if(btn.dataset.action==='plus')  v++;
      inp.value = v;
    });
  });

});
